interface AuditStatsBarProps {
  total: number;
  successCount: number;
  failureCount: number;
  infoCount: number;
  warningCount: number;
  criticalCount: number;
  uniqueUsers: number;
}

export default function AuditStatsBar({ total, successCount, failureCount, infoCount, warningCount, criticalCount, uniqueUsers }: AuditStatsBarProps) {
  const stats = [
    { label: 'Total', value: total, icon: 'ri-file-list-3-line', bg: 'bg-background-50 border-background-200', text: 'text-foreground-800' },
    { label: 'Éxito', value: successCount, icon: 'ri-check-line', bg: 'bg-emerald-50 border-emerald-200', text: 'text-emerald-700' },
    { label: 'Fallidos', value: failureCount, icon: 'ri-close-circle-line', bg: 'bg-red-50 border-red-200', text: 'text-red-600' },
    { label: 'Críticos', value: criticalCount, icon: 'ri-error-warning-line', bg: 'bg-red-50 border-red-200', text: 'text-red-600' },
    { label: 'Advertencias', value: warningCount, icon: 'ri-alert-line', bg: 'bg-amber-50 border-amber-200', text: 'text-amber-700' },
    { label: 'Usuarios', value: uniqueUsers, icon: 'ri-user-3-line', bg: 'bg-background-50 border-background-200', text: 'text-foreground-800' },
  ];

  return (
    <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-2">
      {stats.map((stat) => (
        <div key={stat.label} className={`${stat.bg} border rounded-xl p-3 flex items-center gap-3`}>
          <div className={`w-9 h-9 rounded-lg ${stat.bg} flex items-center justify-center shrink-0`}>
            <i className={`${stat.icon} ${stat.text} text-base`}></i>
          </div>
          <div className="min-w-0">
            <p className="text-foreground-400 text-[9px] font-medium uppercase tracking-wider">{stat.label}</p>
            <p className={`text-sm font-bold ${stat.text}`}>{stat.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}